var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBranch = function SvgBranch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.498 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2.5-1a2.5 2.5 0 0 1-1.75 2.384V10a3.73 3.73 0 0 1 2.25-.75h3A2.25 2.25 0 0 0 13.749 7v-.116A2.499 2.499 0 0 1 14.499 2a2.5 2.5 0 0 1 .75 4.884V7a3.75 3.75 0 0 1-3.75 3.75h-3A2.25 2.25 0 0 0 6.248 13v.116A2.499 2.499 0 0 1 5.498 18a2.5 2.5 0 0 1-.75-4.884V6.884A2.499 2.499 0 0 1 5.498 2a2.5 2.5 0 0 1 2.5 2.5m7.5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-10 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export default SvgBranch;